import NiceModal from '@ebay/nice-modal-react';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import LottiePlayer from 'components/global/LottiePlayer';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent } from 'components/global/styled/Modal.styled';

import fetchRoles from 'services/common/fetchRoles';
import fetchUserDetails from 'services/common/fetchUserDetails';

import { ChangePaymentMethodModal } from '../ChangePaymentMethod/ChangePaymentMethodModal.jsx';
import * as S from './AddPaymentMethod.styled';

const CompletedModal = ({ closeModal, cardLastFour, cancelDowngradeRequest }) => {
	const { t } = useTranslation();

	useEffect(() => {
		fetchUserDetails();
		fetchRoles();
	}, []);

	return (
		<>
			<ModalContent>
				<S.CompletedContainer>
					<LottiePlayer name="alert-success" height="300px" width="300px" />

					<Typography variant="p1" fontWeight="500" noWrap>
						{t('addPaymentMethodSuccessText', {
							cardLastFour
						})}
					</Typography>
				</S.CompletedContainer>
			</ModalContent>

			<ModalActions>
				<Button
					variant="outline"
					label="close"
					onClick={() => {
						closeModal();
						if (cancelDowngradeRequest) {
							NiceModal.show(ChangePaymentMethodModal, {
								cancelDowngradeRequest: true
							});
						}
					}}
				/>
			</ModalActions>
		</>
	);
};

export default CompletedModal;
